export default {
  error_occurred: 'Ocorreu um erro. Tente de novo mais tarde.',
  oops: 'Oops!',
  okay: 'OK',
  title_signout: 'Sair?',
  confirm_signout: 'Voc\u00ea ser\u00e1 desconectado das seguintes equipes',
};



// WEBPACK FOOTER //
// ./src/components/Modal/SignOutModal/I18n/pt-br.js